import proyecto from "../../api/Proyecto";

// Obtener todos los clientes
export const getClientes = async () => {
  try {
    const response = await proyecto.get("/clientes");
    return response.data; // Retorna la lista de clientes
  } catch (error) {
    console.error("Error al obtener clientes:", error.response?.data || error.message);
    throw error.response?.data || { message: "Error al obtener clientes" };
  }
};


// Insertar un nuevo cliente
export const insertarCliente = async (cliente) => {
  try {
    const response = await proyecto.post("/clientes", cliente);
    return response.data; // Retorna el cliente insertado
  } catch (error) {
    console.error("Error al insertar cliente:", error.response?.data || error.message);
    throw error.response?.data || { message: "Error al insertar cliente" };
  }
};

// Actualizar un cliente
// Soporta ambas firmas:
// - actualizarCliente(cliente)
// - actualizarCliente(id, cliente)
export const actualizarCliente = async (idOrCliente, maybeCliente) => {
  try {
    const cliente =
      maybeCliente && typeof maybeCliente === "object" ? maybeCliente : idOrCliente;
    const id =
      typeof idOrCliente === "number" || typeof idOrCliente === "string"
        ? idOrCliente
        : cliente?.id_cliente;

    if (!id) {
      throw new Error("Falta id_cliente para actualizar el cliente");
    }

    const response = await proyecto.put(`/clientes/${id}`, cliente);
    return response.data; // Retorna el cliente actualizado
  } catch (error) {
    console.error("Error al actualizar cliente:", error.response?.data || error.message);
    throw error.response?.data || { message: error.message || "Error al actualizar cliente" };
  }
};


// Eliminar un cliente
export const eliminarCliente = async (id) => {
  try {
    const response = await proyecto.delete(`/clientes/${id}`);
    return response.data; // Retorna la confirmación de eliminación
  } catch (error) {
    console.error("Error al eliminar cliente:", error.response?.data || error.message);
    throw error.response?.data || { message: "Error al eliminar cliente" };
  }
};

// Consultar NIT en Tekra (proxy backend)
export const lookupNitTekra = async (nit) => {
  try {
    const response = await proyecto.post("/clientes/lookup/nit", { nit });
    return response.data;
  } catch (error) {
    console.error("Error al consultar NIT Tekra:", error.response?.data || error.message);
    throw error.response?.data || { message: "Error al consultar NIT Tekra" };
  }
};

// Consultar CUI en Tekra (proxy backend)
export const lookupCuiTekra = async (cui) => {
  try {
    const response = await proyecto.post("/clientes/lookup/cui", { cui });
    return response.data;
  } catch (error) {
    console.error("Error al consultar CUI Tekra:", error.response?.data || error.message);
    throw error.response?.data || { message: "Error al consultar CUI Tekra" };
  }
};
